export default "__VITE_ASSET__vYpXCE6L__"